import React from "react";
import Layout from "../components/layout";
import { SEO } from "../components/seo"
import Section from "../components/section";
import { StaticImage } from "gatsby-plugin-image";
import Knowmore from '../components/knowmore'
import Reasons from '../components/reasons'
import Faqs from '../components/faq'


import {
  wordpressHero,
  doFlex,
  container,
  vertCenter,
  flexColumn,
  divW50,
  marR2,
  headBasic,
  heroImg,
  pad4em,
} from '../components/main.module.scss';

import {
  heroP,
} from '../components/hero.module.scss'
import ManagedTable from "../components/managementplans";


const ManagedServer = () => {
  return (
    <Layout>
      <div className={wordpressHero} style={{backgroundColor: "#e0edf1"}}>
        <div className={`${doFlex} ${container} ${vertCenter}`}>
          <div className={`${doFlex} ${flexColumn} ${divW50} ${marR2} ${pad4em}`}>
            <h1 className={headBasic}>Stree-free Server Management Solutions.</h1>
            <p className={heroP}>Simplify server management with our comprehensive and hassle-free solutions.</p>
          </div>
          <div className={heroImg}>
            <StaticImage src="../images/managedserver.png" alt="Managed Server" layout="constrained" quality="100" />
          </div>
        </div>
      </div>
      <Section sectionName={"Affordable Server Management Package"} sectionType="1" sectionHigh="0">
        <ManagedTable />
      </Section>

      <Knowmore></Knowmore>
      <Section sectionName="Reasons To Choose Us">

        {reasons.map((reason, index) => (
          <Reasons
            key={index}
            reason={reason.name}
            reasonDescription={reason.description}
          > {reason.image} </Reasons>
        ))
        }
      </Section>





      <Section sectionName="Frequently Asked Questions" sectionType="1">
        {faqData.map((data, index) => (
          <Faqs
            key={index}
            questions={data.questions}
            answers={data.answers}
          ></Faqs>
        ))
        }
      </Section>
    </Layout>
  );
};

export default ManagedServer;

const faqData = [
  {
    questions: (
      <>What does server management include?</>
    ),
    answers: (
      <>
        <p>
        Server management includes tasks such as server monitoring, proactive maintenance, security updates, software installations, performance optimization, and troubleshooting. It ensures the smooth operation and optimal performance of your server.
        </p>
      </>
    )
  },
  {
    questions: (
      <>Is server management available for all types of servers??</>
    ),
    answers: (
      <>
        <p>
        Yes, our server management service is available for various types of servers, including dedicated servers, virtual private servers (VPS), cloud servers, and more. We provide comprehensive management solutions tailored to your specific server environment.
        </p>
      </>
    )
  },
  {
    questions: (
      <>What level of support is provided in each management plan?</>
    ),
    answers: (
      <>
        <p>
        Each management plan offers varying levels of support. The Essential plan provides basic support, including monitoring and reactive issue resolution. The Reactive plan includes faster response times and priority support. The Proactive plan offers proactive monitoring, regular maintenance, security audits, and enhanced support.
        </p>
      </>
    )
  },
  {
    questions: (
      <>Can I upgrade or downgrade my server management plan?</>
    ),
    answers: (
      <>
        <p>
        Yes, you have the flexibility to upgrade or downgrade your server management plan based on your changing needs. Whether you require more comprehensive management or want to streamline your services, our team will assist you in making the necessary adjustments.
        </p>
      </>
    )
  },
  {
    questions: (
      <>How quickly can I expect a response from the support team for server management issues?</>
    ),
    answers: (
      <>
        <p>
        Our support team is available 24/7 to address your server management issues. Response times may vary based on the management plan you choose. The Reactive and Proactive plans offer faster response times, ensuring timely resolution of any server-related concerns. Our goal is to provide prompt and efficient support to keep your servers running smoothly.
        </p>
      </>
    )
  },
]


const reasons = [
  {
    name: "24x7 Friendly Support",
    description: "Our friendly and knowledgeable support team is available 24x7 to assist you. We understand that questions and issues can arise at any time, and we're here to provide prompt and helpful support. Whether you have a technical query or need guidance, our team is dedicated to ensuring your experience with us is smooth and seamless.",
    image: <StaticImage src="../images/fsupport.jpg" alt="24x7 Friendly Support" quality="100" />
  },
  {
    name: "Reliable Uptime Guarantee",
    description: "Count on BigBoxHost for a reliable online presence. We guarantee exceptional uptime for your website, ensuring that it remains accessible to your visitors at all times. With our robust infrastructure and proactive monitoring, you can trust us to keep your website up and running, minimizing any potential downtime.",
    image: <StaticImage src="../images/freemigration.jpg" alt="Reliable Uptime Guarantee" quality="100" />
  },
  {
    name: "Monitoring and Protection",
    description: "Your website's security is of utmost importance to us. That's why we employ advanced monitoring and protection measures to safeguard your valuable data. Our comprehensive security protocols, including DDoS protection, malware scanning, and proactive monitoring, ensure that your website stays safe and protected from threats.",
    image: <StaticImage src="../images/monitering.jpg" alt="Monitoring and Protection" quality="100" />
  },
]

export const Head = () => (
  <SEO title="Expert Managed Server Solutions | BigBoxHost" 
  description="Choose hassle-free server management with our expert team. We handle configurations, security, monitoring, patching, and more for seamless performance and reliability."
  pathname="/managed-dedicated-server/"
  />
)